// extracted by mini-css-extract-plugin
export default {"ErrorStateComponentButton":"ErrorStateComponentButton_ErrorStateComponentButton__hp90e","textWrapper":"ErrorStateComponentButton_textWrapper__5T0R1"};